const assetPromises = new Map();
const selectors = '[data-layer-comp="marketo-form"], .mh-ecomm-marketo-form';

function loadAsset(url, type) {
  const key = `${type}:${url}`;
  if (assetPromises.has(key)) return assetPromises.get(key);
  const promise = new Promise((resolve, reject) => {
    const element = document.createElement(type === 'script' ? 'script' : 'link');
    if (type === 'script') element.src = url;
    else {
      element.rel = 'stylesheet';
      element.href = url;
    }
    element.onload = resolve;
    element.onerror = () => reject(new Error(`Unable to load Marketo ${type}: ${url}`));
    document.head.appendChild(element);
  });
  assetPromises.set(key, promise);
  return promise;
}

function discover() {
  const themeUrl = window.Mhecomm_Theme;
  if (!document.querySelector(selectors)) return;
  if (typeof themeUrl !== 'string' || !themeUrl.trim()) {
    console.error('[Marketo] theme asset URL is missing');
    return;
  }
  let baseUrl;
  let stylesheet;
  try {
    baseUrl = new URL(themeUrl);
    if (!['http:', 'https:'].includes(baseUrl.protocol)) throw new Error(`Unsupported Marketo theme URL: ${themeUrl}`);
    stylesheet = /(?:^|\/)sharpen(?:\.css|\/)?$/.test(baseUrl.pathname) ? 'sharpen.css' : 'marketo.css';
  } catch (error) {
    console.error('[Marketo] theme asset resolution failed', error);
    return;
  }
  Promise.all([
    loadAsset(new URL('components/marketo/marketo.js', baseUrl).href, 'script'),
    loadAsset(new URL(`components/marketo/${stylesheet}`, baseUrl).href, 'stylesheet'),
  ]).catch((error) => console.error('[Marketo] asset bootstrap failed', error));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, { once: true });
else discover();
